module.exports = __webpack_public_path__ + "img/monthly-budget-planner_B09QNWZPXN.22cf56cf.jpg";